import "./template-0.scss";
import { useEffect, useState, memo } from "react";
import PROFILE_MOCK from "../../../../assets/images/resume-builder/profile_mock.png";
import { InputResumeBuilderModel } from "../../../../model/resume-builder/input-resume-builder.model";
import { getOneResumeModel } from "../../../../model/resume-builder/get-one-resume.model";


const Template_0_Component = memo(({ containerRef, templ, resultResume }: any) => {
    const [result, setResult] = useState<getOneResumeModel>();
    const [inputTemplateModel, setInputTemplateModel] = useState<InputResumeBuilderModel>(templ);
    const [base64Image, setBase64Image] = useState('');
    useEffect(() => {
        if (templ) {
            setInputTemplateModel(templ);
        }

    }, [templ])

    useEffect(() => {
        if(resultResume){
            console.log('Template-0: resultResume updated', resultResume);
            setResult(resultResume);
        }
    },[resultResume])

    async function convertImageToBase64(url: string) {
        try {
            console.log('Template-0: Converting image to base64, URL:', url);
            
            // Validate URL format
            if (!url || typeof url !== 'string') {
                throw new Error('Invalid URL format');
            }

            // Create a timeout promise
            const timeoutPromise = new Promise((_, reject) => {
                setTimeout(() => reject(new Error('Fetch timeout')), 10000); // 10 second timeout
            });

            // Try to fetch with CORS mode
            const fetchPromise = fetch(url, {
                mode: 'cors',
                credentials: 'omit',
                cache: 'default',
                headers: {
                    'Accept': 'image/*'
                }
            }).catch((fetchError) => {
                // If fetch fails (CORS, network error, etc.), return null to use fallback
                console.warn('Template-0: Fetch failed, will use URL directly:', fetchError);
                return null;
            });

            // Race between fetch and timeout
            const response = await Promise.race([fetchPromise, timeoutPromise]) as Response | null;

            if (!response || !response.ok) {
                throw new Error(`HTTP error! status: ${response?.status || 'unknown'}`);
            }

            const blob = await response.blob();
            
            // Validate that it's actually an image
            if (!blob.type.startsWith('image/')) {
                throw new Error(`Invalid image type: ${blob.type}`);
            }

            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    console.log('Template-0: Image converted to base64 successfully');
                    resolve(reader.result);
                };
                reader.onerror = (error) => {
                    console.error('Template-0: FileReader error:', error);
                    reject(error);
                };
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            // Silently fail and return null - the component will use URL directly as fallback
            console.warn("Template-0: Error converting image to Base64 (will use URL directly):", error);
            return null;
        }
    }

    useEffect(() => {
        console.log('Template-0: Checking result for profile image', {
            hasResult: !!result,
            is_profile_img: result?.is_profile_img,
            profile_img: result?.profile_img,
            profile_img_type: typeof result?.profile_img
        });
        
        if (result && result.is_profile_img && result.profile_img) {
            const profileImgUrl = result.profile_img;
            
            // Check if it's already a base64 string
            if (typeof profileImgUrl === 'string' && profileImgUrl.startsWith('data:image')) {
                console.log('Template-0: Profile image is already base64, using directly');
                setBase64Image(profileImgUrl);
                return;
            }
            
            // Check if it's a valid URL
            if (typeof profileImgUrl === 'string' && (profileImgUrl.startsWith('http://') || profileImgUrl.startsWith('https://'))) {
                console.log('Template-0: Starting image conversion for URL:', profileImgUrl);
                
                convertImageToBase64(profileImgUrl)
                    .then((base64String) => {
                        console.log('Template-0: Conversion result type:', typeof base64String);
                        // Ensure that base64String is a string before calling setBase64Image
                        if (typeof base64String === 'string' && base64String) {
                            console.log('Template-0: Setting base64Image, length:', base64String.length);
                            setBase64Image(base64String);
                        } else {
                            console.warn('Template-0: base64String is not a valid string, using URL directly');
                            // Fallback: use URL directly if conversion fails
                            setBase64Image(profileImgUrl);
                        }
                    })
                    .catch(error => {
                        console.error("Template-0: Error in conversion, using URL directly:", error);
                        // Fallback: use URL directly if conversion fails (browser will handle CORS if needed)
                        setBase64Image(profileImgUrl);
                    });
            } else {
                console.warn('Template-0: Invalid profile image URL format:', profileImgUrl);
                setBase64Image('');
            }
        } else {
            console.log('Template-0: No profile image, resetting base64Image');
            // Reset base64Image if profile image is removed
            setBase64Image('');
        }
    }, [result]);
    return (

        <>
            {
                inputTemplateModel &&
                <div className="template-0-control">
                    <div className="template-0-form-control" ref={containerRef}>


                        <div className="template-0-left-control" style={{
                            backgroundColor:
                                inputTemplateModel.color ?
                                    inputTemplateModel.color.value : "#fff"
                        }}>

                            <div className="template-0-profile-control">
                                {base64Image ? (
                                    <img 
                                        className="template-0-profile" 
                                        src={base64Image} 
                                        alt="Profile" 
                                        onError={(e) => {
                                            console.error('Template-0: Error loading base64 image, using fallback');
                                            if (result?.profile_img && typeof result.profile_img === 'string' && (result.profile_img.startsWith('http://') || result.profile_img.startsWith('https://'))) {
                                                e.currentTarget.src = result.profile_img;
                                            } else {
                                                e.currentTarget.src = PROFILE_MOCK;
                                            }
                                        }}
                                    />
                                ) : result && result.is_profile_img && result.profile_img && (result.profile_img.startsWith('http://') || result.profile_img.startsWith('https://')) ? (
                                    <img 
                                        className="template-0-profile" 
                                        src={result.profile_img} 
                                        alt="Profile" 
                                        onError={(e) => {
                                            console.error('Template-0: Error loading profile image URL, using mock');
                                            e.currentTarget.src = PROFILE_MOCK;
                                        }} 
                                    />
                                ) : (
                                    <img className="template-0-profile" src={PROFILE_MOCK} alt="Profile Mock" />
                                )}
                            </div>
                            {
                                inputTemplateModel.contact && inputTemplateModel.contact.value &&
                                <div className="template-0-item-control">
                                    <div className="d-flex">
                                        <span className="template-0-title-left">Contact</span>
                                    </div>
                                    <div className="template-0-divider"></div>
                                    <div className="template-0-content-control">
                                        <div className="template-0-content" dangerouslySetInnerHTML={{
                                            __html:
                                                inputTemplateModel.contact ?
                                                    inputTemplateModel.contact.value : ""
                                        }}></div>
                                    </div>

                                </div>
                            }
                            {
                                inputTemplateModel.expertise && inputTemplateModel.expertise.value &&
                                <div className="template-0-item-control">
                                    <div className="d-flex">
                                        <span className="template-0-title-left">Expertise</span>
                                    </div>
                                    <div className="template-0-divider"></div>
                                    <div className="template-0-content-control">
                                        <div className="template-0-content" dangerouslySetInnerHTML=
                                            {{
                                                __html:
                                                    inputTemplateModel.expertise ?
                                                        inputTemplateModel.expertise.value : ""
                                            }}></div>
                                    </div>
                                </div>
                            }
                            {
                                inputTemplateModel.language && inputTemplateModel.language.value &&
                                <div className="template-0-item-control">
                                    <div className="d-flex">
                                        <span className="template-0-title-left">Language</span>
                                    </div>
                                    <div className="template-0-divider"></div>
                                    <div className="template-0-content-control">
                                        <div className="template-0-content" dangerouslySetInnerHTML=
                                            {{
                                                __html:
                                                    inputTemplateModel.language ?
                                                        inputTemplateModel.language.value : ""
                                            }}></div>

                                    </div>

                                </div>
                            }
                            {
                                inputTemplateModel.interest && inputTemplateModel.interest.value &&
                                <div className="template-0-item-control">
                                    <div className="d-flex">
                                        <span className="template-0-title-left">Interest</span>
                                    </div>
                                    <div className="template-0-divider"></div>
                                    <div className="template-0-content-control">
                                        <div className="template-0-content" dangerouslySetInnerHTML=
                                            {{
                                                __html:
                                                    inputTemplateModel.interest ?
                                                        inputTemplateModel.interest.value : ""
                                            }}></div>

                                    </div>

                                </div>

                            }

                        </div>
                        <div className="template-0-right-control">
                            <div className="template-0-name-control">
                                <h1 className="template-0-name"></h1>
                                <div className="template-0-content-control">
                                    <span className="template-0-name" dangerouslySetInnerHTML={{
                                        __html:
                                            inputTemplateModel.name ?
                                                inputTemplateModel.name.value : ""
                                    }}></span>
                                </div>
                                <div className="template-0-content-control">
                                    <span className="template-0-position" dangerouslySetInnerHTML={{
                                        __html:
                                            inputTemplateModel.position ?
                                                inputTemplateModel.position.value : ""
                                    }}></span>
                                </div>
                                <div className="template-0-content-control">
                                    <span className="template-0-cover-letter" dangerouslySetInnerHTML={{
                                        __html:
                                            inputTemplateModel.cover_letter ?
                                                inputTemplateModel.cover_letter.value : ""
                                    }}></span>
                                </div>
                                <div className="template-0-exp-control">
                                    <div className="d-flex">
                                        <span className="template-0-exp-title">Experience</span>

                                    </div>
                                    <div className="template-0-exp-divider"></div>
                                    <div className="template-0-content-control">
                                        <div className="template-0-content-black" dangerouslySetInnerHTML={{
                                            __html:
                                                inputTemplateModel.experience ?
                                                    inputTemplateModel.experience.value : ""
                                        }}></div>

                                    </div>
                                </div>
                                <div className="template-0-exp-control">
                                    <div className="d-flex">
                                        <span className="template-0-exp-title">Education</span>

                                    </div>

                                    <div className="template-0-exp-divider"></div>
                                    <div className="template-0-content-control">
                                        <div className="template-0-content-black" dangerouslySetInnerHTML={{
                                            __html:
                                                inputTemplateModel.education ?
                                                    inputTemplateModel.education.value : ""
                                        }}></div>

                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            }

        </>
    )
});

Template_0_Component.displayName = 'Template_0_Component';

export default Template_0_Component;